export enum DataDirection {
    Unknown = 0,
    Incoming = 1,
    Outgoing = 2,
    Both = 3,
}